export { portalAccessForbiddenRoute } from './routes';
